import React, {Fragment} from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Hero from '../components/FAQ/Hero'
import Content from '../components/FAQ/Content'



class AboutUs extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        return(
            <Fragment>
                <Header logoColor="#46e2b9"  classStatic="" dropDownColor="black" title="Albert"/>
                <Hero/>
                <Content/>
                <Footer/>
            </Fragment>
        )
    }
}

export default AboutUs;